import { FC } from 'react';

import ErrorContainer from '../../ErrorContainer';
import Breadcrumbs, { BreadcrumbsProps } from '../breadcrumbs';
import Container, { ContainerProps } from '../container';
import SearchFilter from '../searchFilter';
import Title, { TitleProps } from '../title';

interface OwnProps {
    breadcrumbs?: BreadcrumbsProps;
    container?: ContainerProps;
    showSearchFilter?: boolean;
    title?: TitleProps;
}

type Props = OwnProps;

const Main: FC<Props> = ({ breadcrumbs, title, container, children }) => (
    <>
        <Breadcrumbs {...breadcrumbs} />
        <Title {...title} />
        <SearchFilter />
        <ErrorContainer />
        <Container {...container}>{children}</Container>
    </>
);

export default Main;
